import { useTranslation } from "react-i18next";
import styles from "./tb.module.css";

export function ToggleButton({ width, changeLanguage }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <label className={styles.switch} style={{ width: width + "px" }}>
      <input
        type="checkbox"
        onChange={(e) => {
          const lang = e.target.checked ? "fa" : "en";
          changeLanguage(lang);
          document.cookie = `language=${lang}; path=/; max-age=31536000`;
        }}
        defaultChecked={lang == "fa" ? true : false}
      />
      <span className={`${styles.slider} ${styles.round}`}></span>
    </label>
  );
}
